<app-layout [enableTopGap]="true">
  <section class="error-drive">
    <app-night-drive mode="full" preset="wrong-turn" poster="" [boostTarget]="homeBtn"></app-night-drive>
    <div class="error-drive__content">
      <div class="error-drive__sign" appReveal="rise">
        <span class="brand-icon brand-icon--prohibition error-drive__icon" aria-hidden="true"></span>
        <p class="error-drive__code">404</p>
      </div>
      <a #homeBtn class="dv-pill dv-pill--light cta-sheen" appMagnetic [routerLink]="homeLink">
        <i class="fas fa-arrow-left dv-arrow" aria-hidden="true"></i>
        <span class="magnetic-label">{{ 'navbar.home' | translate }}</span>
      </a>
    </div>
  </section>
</app-layout>
